import React from "react";
import { FaYoutube } from "react-icons/fa";
import { space, color } from "styled-system";
import styled from "styled-components";

const StyledIcon = styled(FaYoutube).attrs((props) => ({
  size: props.size,
}))((props) => props.styles, space, color);

const YoutubeIcon = (props) => {
  return <StyledIcon {...props} />;
};

YoutubeIcon.defaultProps = {
  size: 22,
  styles: {},
};

export default YoutubeIcon;
